import React, {useState} from "react";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useNavigate } from "react-router-dom";
import {Button} from '@mui/material';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [menuIcon, setMenuIcon] = useState(false);
    const navigate = useNavigate('')
    const toggleMenu = () => {
        setIsOpen(!isOpen);
        setMenuIcon(!menuIcon);
    };
    const navHome = () => {
        navigate('/')
    }
    const navOdonto = () => {
        navigate('/Odonto-Luzzi')
    }
    const navEspecialidades = () => {
        navigate('/Especialidades')
    }
    const navEducacional = () => {
        navigate('/Educacional')
    }
    const navEquipe = () => {
        navigate('/Equipe')
    }
    const navBlog = () => {
        navigate('/Blog')
    }
    const navSmileTrips = () => {
        navigate('/Smile-Trips')
    }

    return (
        <div className="header-container">
            <div className="header-content">
                <div className="header-menu">
                    <img src="../images/logoHeader.svg" className="logo" alt="logo" onClick={navHome}/>
                    <a href="https://odontoluzzi.com.br/" className="menu-title">Home</a>
                    <a href="https://odontoluzzi.com.br/Odonto-Luzzi" className="menu-title">Odonto Luzzi</a>
                    <a href="https://odontoluzzi.com.br/Especialidades" className="menu-title">Especialidades</a>
                    <a href="https://odontoluzzi.com.br/Educacional" className="menu-title">Educacional</a>
                    <a href="https://odontoluzzi.com.br/Equipe" className="menu-title">Equipe</a>
                    <a href="https://odontoluzzi.com.br/Blog" className="menu-title">Blog</a>
                    
                    <a href="https://odontoluzzi.com.br/Smile-Trips" className="menu-title">Smile Trips<img src="../images/usa-flag.svg" className="usa-flag" alt="usa-flag"/></a>
                    {isOpen ? '':''}
                    <a href='https://instagram.com/odontoluzzi' style={{textDecoration:'none', color:'#000', marginInline:'6px'}}><InstagramIcon sx={{ fontSize:32, color:'#041819', cursor:'pointer', '&:hover':{color:'#B08E44'}}}/></a>
                    <a href='https://www.facebook.com/profile.php?id=100063743283039' style={{textDecoration:'none', color:'#000', marginInline:'6px'}}><FacebookRoundedIcon sx={{ fontSize:32, color:'#041819', '&:hover':{color:'#B08E44'}}}/></a>
                    <a href='https://wa.me/+554532252800' style={{textDecoration:'none', color:'#000', marginInline:'6px'}}><WhatsAppIcon sx={{ fontSize:32, color:'#041819', '&:hover':{color:'#B08E44'}}}/></a>
                    
                </div>
                {menuIcon ?
                 <><CloseRoundedIcon onClick={toggleMenu} sx={{display:(isOpen ? '' : 'none'), color:'#B08E44', fontSize:36, marginLeft:1.2, cursor:"pointer"}}/></>: 
                 <div className="hamburger-icon" onClick={toggleMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
                }
            </div>
            <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
                <a href="https://odontoluzzi.com.br/" className="menu-title">Home</a>
                <a href="https://odontoluzzi.com.br/Odonto-Luzzi" className="menu-title">Odonto Luzzi</a>
                <a href="https://odontoluzzi.com.br/Especialidades" className="menu-title">Especialidades</a>
                <a href="https://odontoluzzi.com.br/Educacional" className="menu-title">Educacional</a>
                <a href="https://odontoluzzi.com.br/Equipe" className="menu-title">Equipe</a>
                <a href="https://odontoluzzi.com.br/Blog" className="menu-title">Blog</a>
                <a href="https://odontoluzzi.com.br/Smile-Trips" className="menu-title">Smile Trips<img src="../images/usa-flag.svg" className="usa-flag" style={{right:0, top:0}} alt="usa-flag"/></a>

                <a href='https://wa.me/+554532252800' style={{textDecoration:'none', color:'#000', marginInline:'6px'}}>
                    <Button sx={{marginTop:'10px',marginInline:'15px',height:40, border:1, borderRadius:5, borderColor:'#FFF', color:'#FFF', backgroundColor:'#041819', fontSize:'15px', fontWeight:'bold', textTransform: 'none','&:hover': {backgroundColor: '#FFF', borderColor: '#041819', color: '#041819'}, }}>Agente uma avaliação</Button>
                </a>
                <div style={{margin:'20px'}}>

                <a href='https://instagram.com/odontoluzzi' style={{textDecoration:'none', color:'#000', marginInline:'6px'}}><InstagramIcon sx={{ fontSize:32, color:'#FFF', cursor:'pointer', '&:hover':{color:'#B08E44'}}}/></a>
                <a href='https://www.facebook.com/profile.php?id=100063743283039' style={{textDecoration:'none', color:'#000', marginInline:'6px'}}><FacebookRoundedIcon sx={{ fontSize:32, color:'#FFF', '&:hover':{color:'#B08E44'}}}/></a>
                <a href='https://wa.me/+554532252800' style={{textDecoration:'none', color:'#000', marginInline:'6px'}}><WhatsAppIcon sx={{ fontSize:32, color:'#FFF', '&:hover':{color:'#B08E44'}}}/></a>
                </div>
            </div>
        </div>
    )
}
export default Header;